module.exports = __webpack_public_path__ + "img/beefeater-first-block-bg.be029ac9.jpg";